import BackendService from './BackendService';

export default class DealService {
  static getFeedviews() {
    return BackendService.get('/feedviews');
  }

  static getFeedview(feedviewId) {
    return BackendService.get(`/feedviews/${feedviewId}`);
  }

  static createFeedview(data) {
    const feedview = data.feedview;
    return BackendService.post('/feedviews', {
      body: { ...feedview },
    });
  }

  static updateFeedview(feedview) {
    return BackendService.put(`/feedviews/${feedview.id}`, {
      body: feedview,
    });
  }

  static deleteFeedview(feedviewId) {
    return BackendService.delete(`/feedviews/${feedviewId}`);
  }
}
